import React, { useState, useEffect } from 'react';
import { useUser } from '@lore/auth';
import { useQueryMutation } from '@lore/query-connect';
import { GlobeAltIcon, BuildingOfficeIcon } from '@heroicons/react/24/outline';
import CheckboxField from '@/forms/_fields_v2/CheckboxField';
import { useWizard } from '../WizardContext';

export default function Opportunities() {
  const currentUser = useUser();
  const { virtual, inPerson } = currentUser.data;
  const { registerOnBeforeNext, setNextDisabled } = useWizard();

  const userMutation = useQueryMutation('currentUser.updateSingleton', currentUser);

  const [values, setValues] = useState({
    virtual: Boolean(virtual),
    inPerson: Boolean(inPerson)
  });

  function toggle(field) {
    return (event) => setValues(v => ({ ...v, [field]: event.target.checked }));
  }

  useEffect(() => {
    setNextDisabled(!values.virtual && !values.inPerson);
  }, [values.virtual, values.inPerson]);

  useEffect(() => {
    registerOnBeforeNext(async () => {
      setNextDisabled(true);
      try {
        await userMutation.mutateAsync(values);
        return true;
      } catch {
        return false;
      } finally {
        setNextDisabled(false);
      }
    });
  }, [values, registerOnBeforeNext, setNextDisabled, userMutation]);

  return (
    <div className="flex-1 px-6 py-8 space-y-6">
      <div className="space-y-1">
        <h2 className="text-xl font-semibold text-cs-gray-900">
          What type of opportunities are you open to?
        </h2>
        <p className="text-sm text-cs-gray-500">
          This information will help us share relevant opportunities with you
        </p>
      </div>

      <div className="space-y-6">
        <CheckboxField
          label={(
            <div className="flex items-center space-x-2">
              <GlobeAltIcon className="size-5 shrink-0" />
              <span className="font-semibold">Virtual</span>
            </div>
          )}
          description="Collaborate with people locally and nationally. Virtual connections make it easy to collaborate and open the door to more opportunities."
          checked={values.virtual}
          onChange={toggle('virtual')}
        />
        <CheckboxField
          label={(
            <div className="flex items-center space-x-2">
              <BuildingOfficeIcon className="size-5 shrink-0" />
              <span className="font-semibold">In-person</span>
            </div>
          )}
          description="Connect and collaborate with people in your local community."
          checked={values.inPerson}
          onChange={toggle('inPerson')}
        />
      </div>
    </div>
  );
}
